import getAllSalesAgents from '../../api/SalesAgents/getAllSalesAgents.api';
import { GET_ALL_SALESAGENTS_SUCCESS, GET_ALL_SALESAGENTS_FAIL } from './types';

export const getSalesAgents = () => {
	return async (dispatch) => {
		console.log(' in getSalesAgents ==========>');
		try {
			getAllSalesAgents((returned) =>
				dispatch(getSalesAgentsSuccess(returned))
			);
		} catch (error) {
			getSalesAgentsFail(error);
		}
	};
};

const getSalesAgentsSuccess = (payload) => ({
	type: GET_ALL_SALESAGENTS_SUCCESS,
	payload,
});

const getSalesAgentsFail = (payload) => ({
	type: GET_ALL_SALESAGENTS_FAIL,
	payload,
});
